<template>
	<div style="margin: 0px auto; width:72%;">
		<div class="center fs18 mb30" style="padding-top: 40px;">
		    <p class="black fs32 fw500">{{ $t('process6') }}</p>
		    <span class="backyel dib divide"></span>
		</div>
		
		<el-card class="box-card showInLargeb" shadow="Always" style="margin-bottom: 2rem;">
		    <el-row :gutter="60">
		        <el-col :span="8">
					<div class="grid-content ep-bg-purple">
						<img class="mcenter pimage" src="../assets/process_detail1.png" alt="">
					</div>
				</el-col>
		        <el-col :span="8">
					<div class="grid-content ep-bg-purple">
						<img class="mcenter pimage" src="../assets/process_detail2.png" alt="">
					</div>
				</el-col>
		        <el-col :span="8">
					<div class="grid-content ep-bg-purple">
						<img class="mcenter pimage" src="../assets/process_detail3.png" alt="">
					</div>
				</el-col>
			</el-row>
			<el-row :gutter="60">
			  <el-col :span="8">
				  <div class="grid-content1 ep-bg-purple" >
					  {{ detail.estimate_flight_to_hk }}
				  </div>
			  </el-col>
			  <el-col :span="8">
				  <div class="grid-content1 ep-bg-purple" >
					  {{ detail.days_left }}
				  </div>
			  </el-col>
			  <el-col :span="8">
				  <div class="grid-content1 ep-bg-purple" >
					  {{ detail.helper_code }}
				  </div>
			  </el-col>
			</el-row>
			<el-row :gutter="60">
				<el-col :span="8">
					<div class="grid-content2 ep-bg-purple" >
						{{ $t('proz1') }}
					</div>
				</el-col>
				<el-col :span="8">
					<div class="grid-content2 ep-bg-purple" >
						{{ $t('proz2') }}
					</div>
				</el-col>
				<el-col :span="8">
					<div class="grid-content2 ep-bg-purple" >
						{{ $t('proz3') }}
					</div>
				</el-col>
			</el-row>
		</el-card>
		
		<el-card class="box-card showInSmallb" shadow="Always" style="margin-bottom: 2rem;">
			<el-row :gutter="60">				<el-col :span="6">					<div class="grid-content ep-bg-purple">						<img class="mcenter pimage" src="../assets/process_detail1.png" alt="">					</div>				</el-col>
				<el-col :span="9">
					<div class="grid-content2 ep-bg-purple" >
						{{ $t('proz1') }}
					</div>
				</el-col>				<el-col :span="9">					<div class="grid-content2 ep-bg-purple" style="margin-top: 0.5625rem;">
						{{ detail.estimate_flight_to_hk }}
					</div>				</el-col>			</el-row>
			<el-row :gutter="60">
				<el-col :span="6">
					<div class="grid-content ep-bg-purple">
						<img class="mcenter pimage" src="../assets/process_detail2.png" alt="">
					</div>
				</el-col>
				<el-col :span="9">
					<div class="grid-content2 ep-bg-purple" style="margin-top: 0.5625rem;">
						{{ $t('proz2') }}
					</div>
				</el-col>
				<el-col :span="9">
					<div class="grid-content2 ep-bg-purple" style="margin-top: 0.5625rem;">
						{{ detail.days_left }}
					</div>
				</el-col>
			</el-row>
			<el-row :gutter="60">
				<el-col :span="6">
					<div class="grid-content ep-bg-purple">
						<img class="mcenter pimage" src="../assets/process_detail3.png" alt="">
					</div>
				</el-col>
				<el-col :span="9">
					<div class="grid-content2 ep-bg-purple" >
						{{ $t('proz3') }}
					</div>
				</el-col>
				<el-col :span="9">
					<div class="grid-content2 ep-bg-purple">
						{{ detail.helper_code }}
					</div>
				</el-col>
			</el-row>
		</el-card>
		
		<el-row class="showInLargeb" :gutter="20" v-if="['{}','[]'].indexOf(JSON.stringify(detail)) == -1">
		    <el-col :span="12">
				<el-card class="box-card" shadow="Always" style="margin-bottom: 2rem;">
					<template #header>
					      <div class="card-header">
					        <span style="color: white;">{{$t('proh1')}}</span>
					      </div>
					</template>
					
					<el-row :gutter="60">
						<el-col :span="12">
							<div class="ep-bg-purple" >
								{{$t('proh2')}}:
							</div>
						</el-col>
						<el-col :span="12">
							<div class="ep-bg-purple" >
								{{ detail.helper_name }}
							</div>
						</el-col>
					</el-row>
					
					<el-row :gutter="60">
						<el-col :span="12">
							<div class="ep-bg-purple" >
								{{$t('proh3')}}:
							</div>
						</el-col>
						<el-col :span="12">
							<div class="ep-bg-purple" >
								{{ detail.typeStr }}
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="60">
						<el-col :span="12">
							<div class="ep-bg-purple" >
								{{$t('proh4')}}:
							</div>
						</el-col>
						<el-col :span="12">
							<div class="ep-bg-purple" >
								{{ detail.helper_visa_start_date }}
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="60">
						<el-col :span="12">
							<div class="ep-bg-purple" >
								{{$t('proh5')}}:
							</div>
						</el-col>
						<el-col :span="12">
							<div class="ep-bg-purple" >
								{{ detail.helper_visa_expiry_date }}
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="60" v-if="worker_type == 4 || worker_type == 6">
						<el-col :span="12">
							<div class="ep-bg-purple" >
								{{$t('proh6')}}:
							</div>
						</el-col>
						<el-col :span="12">
							<div class="ep-bg-purple" >
								{{ detail.helper_go_down_date }}
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="60" v-if="worker_type == 1 || worker_type == 2 || worker_type == 3">
						<el-col :span="12">
							<div class="ep-bg-purple" >
								{{$t('proh7')}}:
							</div>
						</el-col>
						<el-col :span="12">
							<div class="ep-bg-purple" >
								{{ detail.flight_arrival_date }}
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="60">
						<el-col :span="12">
							<div class="ep-bg-purple" >
								{{$t('proh8')}}:
							</div>
						</el-col>
						<el-col :span="12">
							<div class="ep-bg-purple" >
								{{ detail.contract_start_date }}
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="60">
						<el-col :span="12">
							<div class="ep-bg-purple" >
								{{$t('proh9')}}:
							</div>
						</el-col>
						<el-col :span="12">
							<div class="ep-bg-purple" >
								{{ detail.contract_renewal_reminder_date }}
							</div>
						</el-col>
					</el-row>
				</el-card>	
			</el-col>
		    <el-col :span="12">
				<el-card class="box-card" shadow="Always" style="margin-bottom: 2rem;">
					<template #header>
					      <div class="card-header" >
					        <span style="color: white;">{{ $t('proe4') }}</span>
					      </div>
					</template>
					
					<el-row :gutter="60">
						<el-col :span="12">
							<div class="ep-bg-purple" >
								{{ $t('proe1') }}:
							</div>
						</el-col>
						<el-col :span="12">
							<div class="ep-bg-purple" >
								{{ detail.employer_name }}
							</div>
						</el-col>
					</el-row>
					
					<el-row :gutter="60">
						<el-col :span="12">
							<div class="ep-bg-purple" >
								{{ $t('proe2') }}:
							</div>
						</el-col>
						<el-col :span="12">
							<div class="ep-bg-purple" >
								{{ detail.employer_mobile }}
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="60">
						<el-col :span="12">
							<div class="ep-bg-purple" >
								{{ $t('proe3') }}:
							</div>
						</el-col>
						<el-col :span="12">
							<div class="ep-bg-purple" >
								{{ detail.mailing_address }}
							</div>
						</el-col>
					</el-row>	
				</el-card>	
			</el-col>
		 </el-row>
		
		<el-row class="showInSmallb" :gutter="20" v-if="['{}','[]'].indexOf(JSON.stringify(detail)) == -1">
			<el-col class="smallmidsize">
				<el-card class="box-card" shadow="Always" style="margin-bottom: 2rem;">
					<template #header>
					      <div class="card-header">
					        <span style="color: white;">{{$t('proh1')}}</span>
					      </div>
					</template>
					
					<el-row :gutter="60">
						<el-col :span="10">
							<div class="ep-bg-purple" >
								{{$t('proh2')}}:
							</div>
						</el-col>
						<el-col :span="14">
							<div class="ep-bg-purple" >
								{{ detail.helper_name }}
							</div>
						</el-col>
					</el-row>
					
					<el-row :gutter="60">
						<el-col :span="10">
							<div class="ep-bg-purple" >
								{{$t('proh3')}}:
							</div>
						</el-col>
						<el-col :span="14">
							<div class="ep-bg-purple" >
								{{ detail.typeStr }}
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="60">
						<el-col :span="10">
							<div class="ep-bg-purple" >
								{{$t('proh4')}}:
							</div>
						</el-col>
						<el-col :span="14">
							<div class="ep-bg-purple" >
								{{ detail.helper_visa_start_date }}
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="60">
						<el-col :span="10">
							<div class="ep-bg-purple" >
								{{$t('proh5')}}:
							</div>
						</el-col>
						<el-col :span="14">
							<div class="ep-bg-purple" >
								{{ detail.helper_visa_expiry_date }}
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="60" v-if="worker_type == 4 || worker_type == 6">
						<el-col :span="10">
							<div class="ep-bg-purple" >
								{{$t('proh6')}}:
							</div>
						</el-col>
						<el-col :span="14">
							<div class="ep-bg-purple" >
								{{ detail.helper_go_down_date }}
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="60" v-if="worker_type == 1 || worker_type == 2 || worker_type == 3">
						<el-col :span="10">
							<div class="ep-bg-purple" >
								{{$t('proh7')}}:
							</div>
						</el-col>
						<el-col :span="14">
							<div class="ep-bg-purple" >
								{{ detail.flight_arrival_date }}
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="60">
						<el-col :span="10">
							<div class="ep-bg-purple" >
								{{$t('proh8')}}:
							</div>
						</el-col>
						<el-col :span="14">
							<div class="ep-bg-purple" >
								{{ detail.contract_start_date }}
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="60">
						<el-col :span="10">
							<div class="ep-bg-purple" >
								{{$t('proh9')}}:
							</div>
						</el-col>
						<el-col :span="14">
							<div class="ep-bg-purple" >
								{{ detail.contract_renewal_reminder_date }}
							</div>
						</el-col>
					</el-row>
					
				</el-card>	
			</el-col>
			<el-col class="smallmidsize" :span="24">
					<el-card class="box-card" shadow="Always" style="margin-bottom: 2rem;">
						<template #header>
							  <div class="card-header" >
								<span style="color: white;">{{ $t('proe4') }}</span>
							  </div>
						</template>
						
						<el-row :gutter="60">
							<el-col :span="10">
								<div class="ep-bg-purple" >
									{{ $t('proe1') }}:
								</div>
							</el-col>
							<el-col :span="14">
								<div class="ep-bg-purple" >
									{{ detail.employer_name }}
								</div>
							</el-col>
						</el-row>
						
						<el-row :gutter="60">
							<el-col :span="10">
								<div class="ep-bg-purple" >
									{{ $t('proe2') }}:
								</div>
							</el-col>
							<el-col :span="14">
								<div class="ep-bg-purple" >
									{{ detail.employer_mobile }}
								</div>
							</el-col>
						</el-row>
						<el-row :gutter="60">
							<el-col :span="10">
								<div class="ep-bg-purple" >
									{{ $t('proe3') }}:
								</div>
							</el-col>
							<el-col :span="14">
								<div class="ep-bg-purple" >
									{{ detail.mailing_address }}
								</div>
							</el-col>
						</el-row>	
					</el-card>	
				</el-col>
			</el-row>
		</el-row>
		
		<el-timeline v-if = "JSON.stringify(list) != '[]'">
			  <!-- dayNum[v.process_num] -->
			  <el-timeline-item v-for="v in list" 
			  :timestamp="v.show_time" 
			  placement="top" 
			  size="large"
			  :key="v.process_num"
			  :type="v.is_finish == 1 ? 'success' : '' " >
				<el-card>
				  <h4>
					  <span>{{ v.title}}</span>
					  <el-button v-if="v.files.length > 0 " type="info" size="small" round plain style="margin: 0 0.625rem;" @click="showDetail(v)">show detail</el-button>
					  <!-- <span v-if="v.is_delay == 1" style="font-size: 0.625rem;color: #FE5F03;margin: 0.625rem 0.625rem">
						  {{ v.delayDate }}
					  </span> -->
				  </h4>
				  <!-- <p v-if="v.remark != ''" style="margin-top: 0.625rem;font-size: 0.625rem;">
					  <span style="color: #0d6aad;font-weight: bolder;margin: 0 0.625rem">Remark</span>
					  <span>{{ v.remark }}</span>
				  </p> -->
				</el-card>
			  </el-timeline-item>
		</el-timeline>
		<div>
			  <el-dialog
				title="Annex"
				:visible.sync="dialogVisible"
				width="60%"
				center>
				<el-card class="box-card" shadow="Always">
				  <div v-for="item in files" style="margin-top: 0.3125rem;">
					  <pdf v-if="item.substring(item.lastIndexOf('.') + 1).toLowerCase() == 'pdf'"
						ref="pdf"
						:src="item">
					  </pdf>
					  <img v-else :src="item" style="width: 62.5rem" />
				  </div>
				</el-card>
			  </el-dialog>
		</div>
	</div>
</template>
<script>
import pdf from 'vue-pdf';
export default {
	name: 'ProcessDetail',
	props: ['id'],
	components:{
	      pdf
	},
	data() {
		const lang = this.$i18n.locale;
	    return {
			lang,
	        detail:[],
			list:[],
			dayNum:[],
			dialogVisible: false,
			files: [],
			worker_type: 0,
	    }
	},
	watch: {
		lang(value) {
			this.$i18n.locale = value;
			localStorage.setItem('locale', value);
			location.reload();
		},
	},
	computed: {
		
	},
	created(){
		const param = {};
		param.id = this.id;
		param.lang = this.lang;
		this.$service.getProcessDetail(param).then((res) => {
			if (JSON.stringify(res.data) != "{}" && JSON.stringify(res.data) != "[]") {
				this.detail = res.data.detail;
				let rList = res.data.list;
				if (this.$i18n.locale != "en" && JSON.stringify(rList) != "[]"){
					for (var i = 0; i < rList.length; i++) {
						if (i == 0) {
							rList[i]['title'] = "確認日期";
						}else{
							break;
						}
					}
				}
				this.list = rList;
				this.dayNum = res.data.dayNum;
				this.worker_type = res.data.detail.worker_type;
			}
		});
	},
	methods:{
		showDetail(data){
			this.dialogVisible = true;
			this.files = data.files;
		}
	}
}	
</script>

<style>
.el-card .el-card__header {
	background-color: #21374D;
	border-top-left-radius: 2rem;
	border-top-right-radius: 2rem;
}
.el-row {
  margin-bottom: 1.25rem;
}
.el-row:last-child {
  margin-bottom: 0;
}
.el-col {
  border-radius: 0.25rem;
}

.grid-content {
  height: 5rem;
  text-align: center;
  line-height: 4rem;
}
.grid-content1 {
  height: 2rem;
  text-align: center;
  line-height: 2rem;
  font-size: 1.875rem;
  font-weight: 400;
}
.grid-content2 {
  height: 2rem;
  text-align: center;
  line-height: 2rem;
  color: #EFCD24;
  font-weight: 500;
}

@media screen and (max-width: 770px) {
	.grid-content2 {
		height: 3rem;
		text-align: center;
		color: #EFCD24;
		font-weight: 500;
		font-size: 0.625rem;
	}	
	.pimage {
		height: 60px;
		width: 60px;
	}
	.smallmidsize {
		font-size: 0.625rem;
	}
	.card-header {
		text-align: center;
	}
}

</style>
